import { useEffect, useMemo } from "react";
import ProjectionLoadState from "../ProjectionLoadState";
import { useProjectActions, useProjectContext } from "@contexts/projects";
import AccordionItem from "./AccordionItem";
import { useDashboardUIContext } from "@contexts/dashboardUI";

const ServiceAccordion = ({parent}) => {
  
  const { barChartDate } = useDashboardUIContext()
  const {activeProject: {_id, services = {}}, filterDates} = useProjectContext();
  const { loadServices } = useProjectActions();

  useEffect(() => {
    if(_id) {
      loadServices(parent, barChartDate);
    } 
  },[_id, filterDates, barChartDate])

  const substepServices = useMemo(() => services[parent], [services, parent])

  return (
    <>
      <ProjectionLoadState
        level="services"
        parent={parent}
        isMissing={!substepServices}
        onRetry={() => loadServices(parent, barChartDate)}
      />
      {substepServices?.map((item, index) => <AccordionItem key={index} item={item} type={"service"} typeTitle={"Serviço"}/>)}
    </>
  )
}

export default ServiceAccordion;
